<div class="general-page-content">
  <router-outlet></router-outlet>
</div>
